import React, { Suspense } from 'react';
import {
  Spinner,
  translationsHocSetup,
  createWithEnumsHookContext
} from '@core/components';
import { NavItem, NavItemCustomProps } from '../withNavLayout';

const withLazy = (
  WrappedComponent: React.FC<unknown>,
  customProps: NavItemCustomProps = {}
) => (props: unknown) => (
  <Suspense fallback={<Spinner />}>
    <WrappedComponent {...props} {...customProps} />
  </Suspense>
);

const wrapComponent = (
  component: React.FC<any> | undefined,
  moduleId: string
) => {
  if (!component) return undefined;

  const componentWTranslations = translationsHocSetup(moduleId)(component);

  return createWithEnumsHookContext(moduleId)(componentWTranslations);
};

const setUpPreForNavItems = (
  navItems: NavItem[],
  moduleId: string
): NavItem[] =>
  navItems.map((x) => {
    if (!x.text) return x;

    const text = `${moduleId}${x.text}`;

    const tooltip = x.tooltip ? `${moduleId}${x.tooltip}` : undefined;

    const tlFields = {
      component: wrapComponent(x.component, moduleId),
      text,
      tooltip,
      translationsPre: moduleId
    };

    if (x.items) {
      return {
        ...x,
        ...tlFields,
        items: setUpPreForNavItems(x.items, moduleId)
      };
    }

    return { ...x, ...tlFields };
  });

const prepareSuspenseForNavComponents = (navItems: NavItem[]): NavItem[] =>
  navItems.map((x) => {
    const component = x.component
      ? withLazy(x.component, x.customProps)
      : undefined;

    if (x.items) {
      return {
        ...x,
        component,
        items: prepareSuspenseForNavComponents(x.items)
      };
    }

    return { ...x, component };
  });

export const prepareNavItems = (
  navItems: NavItem[],
  moduleId: string | undefined
) => {
  const moduleNavItems = moduleId
    ? setUpPreForNavItems(navItems, moduleId)
    : navItems;

  return prepareSuspenseForNavComponents(moduleNavItems);
};
